import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './local/en.json'
import ar from './local/ar.json'
import de from './local/de.json'
import es from './local/es.json'
import id from './local/id.json'
import malaysia from './local/malaysia.json'
import pt from './local/pt.json'
import ru from './local/ru.json'
import th from './local/th.json'
import vi from './local/vi.json'
import yd from './local/yd.json'
import cn from './local/cn.json'
import it from './local/it.json'
import fr from './local/fr.json'
import nz from './local/nz.json'
import sv from './local/sv.json'
import nb from './local/nb.json'
import svpl from './local/svpl.json'
import enadly from './local/enadly.json'
import arzd from './local/arzd.json'
import ruzy from './local/ruzy.json'
import kr from './local/kr.json'
import jp from './local/jp.json'
import dny from './local/dny.json'
import oz from './local/oz.json'
import fz from './local/fz.json'



Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en', // set locale
    // fallbackLocale: 'en',
    // silentTranslationWarn: true,
    messages: {
        en, ar, de, es, id, malaysia, pt, ru, th, vi, yd, cn, it, fr, nz, sv, nb, svpl, enadly,
        arzd, ruzy, kr, jp, dny, oz, fz
    }
})

// 初始化时尝试从 localStorage 读取语言设置
// 如果 localStorage 中没有数据，则保持默认的 'en'
if (localStorage.getItem('dominItem')) {
    try {
        const dominItem = JSON.parse(localStorage.getItem('dominItem'));
        if (dominItem.nationId) {
            i18n.locale = dominItem.nationId;
        }
    } catch (error) {
        console.warn('Failed to parse dominItem from localStorage:', error);
    }
}

// i18n.locale = localStorage.getItem('dominItem') ?
//     JSON.parse(localStorage.getItem('dominItem')).nationId : 'en'
